// Klever Shop: OpenAI Ads measures only successfully saved web quote requests.
// Public pixel ID, never an API key. No customer fields are added to the event.
(() => {
  if (window.kleverOpenAIQuoteMeasurement || window.Shopify?.designMode) return;
  window.kleverOpenAIQuoteMeasurement = true;
  const pixelId = 'XR4XKYpvomegjmMdLmwFWr';
  const sdkUrl = 'https://bzrcdn.openai.com/sdk/oaiq.min.js';
  const measured = new Set();
  const inFlight = new Set();
  let sdkPromise = null;
  let initialized = false;
  function allowed() {
    try {
      const privacy = window.Shopify?.customerPrivacy;
      return !!privacy && privacy.analyticsProcessingAllowed() === true && privacy.marketingAllowed() === true && privacy.saleOfDataAllowed() === true;
    } catch { return false; }
  }
  window.kleverOpenAIQuoteContext = () => {
    if (!allowed()) return undefined;
    const cookie = name => {
      try { const part=document.cookie.split(';').map(s=>s.trim()).find(s=>s.startsWith(name+'='));return part?decodeURIComponent(part.slice(name.length+1)):''; } catch { return ''; }
    };
    const raw = new URL(window.location.href).searchParams.get('oppref') || cookie('__oppref');
    const obref = cookie('__obref');
    return {consent:true,consentedAt:Date.now(),...(raw&&raw.length<=4096&&!/[\x00-\x20\x7f]/.test(raw)?{oppref:raw}:{}),...(/^[a-f0-9]{8}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{12}$/i.test(obref)?{obref}:{})};
  };
  // Internal analytics uses only Shopify's analytics permission, independently of Ads.
  // Reuse the navigation pixel's normalized arrival category; never forward a raw URL.
  const origins = ['google','openai','bing','facebook','instagram','linkedin','tiktok','youtube','x','pinterest','whatsapp','telegram','other_referral','other_campaign','direct_unknown','unknown'];
  const validOrigin = v => v && origins.includes(v.source) && (v.source==='unknown'?v.basis==='unknown':v.source==='direct_unknown'?v.basis==='none':v.source==='other_campaign'?v.basis==='utm':v.source==='other_referral'?v.basis==='referrer':['utm','referrer'].includes(v.basis));
  const belongs = (host, domain) => host===domain || host.endsWith('.'+domain);
  function arrivalOrigin() {
    try {
      const tag = new URL(window.location.href).searchParams.get('utm_source');
      if (tag) {
        const aliases={google:'google','google.com':'google',adwords:'google',googleads:'google',chatgpt:'openai','chatgpt.com':'openai',openai:'openai','openai.com':'openai',bing:'bing','bing.com':'bing',microsoft:'bing',facebook:'facebook','facebook.com':'facebook',fb:'facebook',meta:'facebook',instagram:'instagram','instagram.com':'instagram',ig:'instagram',linkedin:'linkedin','linkedin.com':'linkedin',tiktok:'tiktok','tiktok.com':'tiktok',youtube:'youtube','youtube.com':'youtube',twitter:'x','twitter.com':'x',x:'x','x.com':'x',pinterest:'pinterest','pinterest.com':'pinterest',whatsapp:'whatsapp','whatsapp.com':'whatsapp',telegram:'telegram','telegram.org':'telegram'};
        const name=tag.trim().toLowerCase();return {source:Object.hasOwn(aliases,name)?aliases[name]:'other_campaign',basis:'utm'};
      }
      if(!document.referrer)return {source:'direct_unknown',basis:'none'};
      const ref=new URL(document.referrer),host=ref.hostname.toLowerCase();
      if(!['https:','http:'].includes(ref.protocol)||['klever-shop.cl','ncxv1b-0u.myshopify.com'].some(d=>belongs(host,d)))return {source:'unknown',basis:'unknown'};
      const domains={openai:['chatgpt.com','openai.com'],google:['google.com','google.cl','google.es','google.co.uk','google.com.ar','google.com.br','google.com.mx','google.ca','google.de','google.fr','google.it','google.com.au','google.co.in','google.co.jp'],bing:['bing.com'],facebook:['facebook.com','fb.com'],instagram:['instagram.com'],linkedin:['linkedin.com','lnkd.in'],tiktok:['tiktok.com'],youtube:['youtube.com','youtu.be'],x:['x.com','twitter.com','t.co'],pinterest:['pinterest.com','pin.it'],whatsapp:['whatsapp.com','wa.me'],telegram:['telegram.org','t.me']};
      for(const [source,hosts] of Object.entries(domains))if(hosts.some(d=>belongs(host,d)))return {source,basis:'referrer'};
      return {source:'other_referral',basis:'referrer'};
    }catch{return {source:'unknown',basis:'unknown'};}
  }
  const originStorage='ks_quote_origin_v1';
  function analyticsAllowed(){try{return window.Shopify?.customerPrivacy?.analyticsProcessingAllowed()===true;}catch{return false;}}
  function quoteOrigin(){
    if(!analyticsAllowed()){try{window.sessionStorage?.removeItem(originStorage);}catch{}return undefined;}
    let origin=null;
    try{
      const raw=(document.cookie||'').split(';').map(s=>s.trim()).find(s=>s.startsWith('ks_live_origin='));
      const parts=raw?.slice('ks_live_origin='.length).split('.');
      const v=parts?.length===3?{source:parts[1],basis:parts[2]}:null;
      if(validOrigin(v))origin=v;
    }catch{}
    if(!origin)try{
      const saved=JSON.parse(window.sessionStorage?.getItem(originStorage)||'null');
      if(validOrigin(saved)&&Number.isSafeInteger(saved.at)&&saved.at<=Date.now()&&Date.now()-saved.at<1800000)origin={source:saved.source,basis:saved.basis};
    }catch{}
    const candidate=arrivalOrigin();
    if(!origin||origin.source==='unknown'&&['utm','referrer'].includes(candidate.basis))origin=candidate;
    try{window.sessionStorage?.setItem(originStorage,JSON.stringify({...origin,at:Date.now()}));}catch{}
    return {consent:true,consentedAt:Date.now(),...origin};
  }
  window.kleverQuoteTrafficContext=quoteOrigin;
  function queue() {
    if (window.oaiq) return;
    const q = function () { q.q.push(arguments); };
    q.q = [];
    window.oaiq = q;
  }
  function loadSdk() {
    if (!allowed()) return Promise.resolve(false);
    if (sdkPromise) return sdkPromise;
    queue();
    // The SDK defaults to consent granted. Set it explicitly before initialization.
    window.oaiq('consent', false);
    window.oaiq('init', { pixelId });
    initialized = true;
    window.oaiq('consent', allowed());
    sdkPromise = new Promise(resolve => {
      const script = document.createElement('script');
      script.async = true;
      script.src = sdkUrl;
      script.onload = () => resolve(true);
      script.onerror = () => { sdkPromise = null; resolve(false); };
      document.head.appendChild(script);
    });
    return sdkPromise;
  }
  function updateConsent() {
    quoteOrigin();
    if (initialized) window.oaiq('consent', allowed());
    if (allowed()) void loadSdk();
    // Never replay events that happened while measurement was denied.
  }
  async function quoteSubmitted(event) {
    const requestId = event.detail?.request_id || window.kleverWebSubmission?.id;
    if (typeof requestId !== 'string' || !/^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(requestId) || !allowed()) return;
    const eventId = 'ks_web_quote_' + requestId.toLowerCase();
    if (measured.has(eventId) || inFlight.has(eventId)) return;
    inFlight.add(eventId);
    try {
      if (!await loadSdk() || !allowed()) return;
      // Reuse this exact ID on all retries: OpenAI deduplicates pixel + event + ID.
      window.oaiq('measure', 'lead_created', { type: 'customer_action' }, { event_id: eventId });
      measured.add(eventId);
    } catch {} finally { inFlight.delete(eventId); }
  }
  window.addEventListener('klever:quote-submitted', quoteSubmitted);
  document.addEventListener('visitorConsentCollected', updateConsent);
  if (window.Shopify?.customerPrivacy) updateConsent();
  else if (window.Shopify?.loadFeatures) {
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.2' }], error => { if (!error) updateConsent(); });
  }
})();
